import { useMemo, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { ConfigProvider } from "antd";
import Popup from "../../../Helpers/Popup/Popup";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import Button from "../../../Helpers/Button/Button";
import trans, { isRTL } from "../../../../utils";
import { toast } from "react-toastify";
import {
  useGetSpecificFormQuery,
  useCreateSupervisorFormSubmissionMutation,
} from "../../../../Redux/service/Forms/Form";
import EditableFormFields from "./EditableFormFields";

export default function SupervisorSubmitFormPopup({
  taskId,
  formId,
  formName,
  onClose,
  onSuccess,
  zIndex = 1300,
}) {
  const modalRef = useRef(null);
  const [fields, setFields] = useState([]);
  const emptyValues = useMemo(() => [], []);
  const { data: formData, isLoading } = useGetSpecificFormQuery(formId, {
    skip: !formId,
  });
  const [submit, { isLoading: isSubmitting }] =
    useCreateSupervisorFormSubmissionMutation();

  const handleSave = async () => {
    try {
      await submit({
        taskId,
        formId,
        fields,
      }).unwrap();

      toast.success(trans("Form submitted successfully"), {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar",
      });

      onClose();
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      toast.error(
        trans(err?.data?.message || "Failed to submit form"),
        {
          autoClose: 2000,
          rtl: localStorage.getItem("lang") === "ar",
        }
      );
    }
  };

  if (!formId) return null;

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#0f6936",
          activeBg: "#0f6936",
          activeBorderColor: "#2e9245",
          zIndexPopupBase: 2000,
        },
      }}
      getPopupContainer={() => modalRef.current || document.body}
    >
      <Popup show={!!formId} zIndex={zIndex}>
        <div ref={modalRef} style={{ position: "relative" }}>
          <Modal.Header className="modal-header flex-between">
            <Modal.Title id="contained-modal-title-vcenter">
              <PopupTitle
                headtitle={trans("Submit Form")}
                subtitle={formName || formData?.data?.name}
              />
            </Modal.Title>
            <Close
              // eslint-disable-next-line react/style-prop-object
              style="close-32 close"
              close={onClose}
              img="Close"
            />
          </Modal.Header>
          <Modal.Body
            className="modal-body-scrollable fixed-popup-height"
            style={{ overflowX: "hidden" }}
            dir={isRTL ? "rtl" : "ltr"}
          >
            {isLoading ? (
              <div className="text-center p-3 text-muted">
                {trans("Loading form...")}
              </div>
            ) : (
              <EditableFormFields
                schemaFields={formData?.data?.formSchema?.fields}
                valuesFields={emptyValues}
                onChange={setFields}
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="popups-footer gap-8">
              <Button
                type="primary"
                text={trans("Submit")}
                htmlType="button"
                onClick={handleSave}
                loading={isSubmitting}
                disabled={isSubmitting || isLoading}
              />
              <Button
                type="default"
                text={trans("Cancel")}
                htmlType="button"
                onClick={onClose}
              />
            </div>
          </Modal.Footer>
        </div>
      </Popup>
    </ConfigProvider>
  );
}
